<template>
	<svg t="1686291888473" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3000"
		xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">
		<path
			d="M65.616 54.606v398.5h398.5v-398.5z m508.33 0.61v398.51h398.5V55.216z m-507.41 511.09v398.5h398.5v-398.5z m508.33 0.61v398.5h398.5v-398.5z"
			p-id="3001"></path>
	</svg>
</template>
